import type { IconData } from '@stacksjs/iconify-core'

export const cat: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M374.762 186.866a54.1 54.1 0 0 0-51.305-36.706H280V21.552l-18.263 2.609c-41.429 5.918-73.7 26.912-95.907 62.4c-16.011 25.581-23.454 53.8-26.908 74.906c-23.847 18.348-44.593 43.611-61.738 75.2c-14.449 26.618-26.41 57.816-35.552 92.729c-15.447 58.99-17.538 107.921-17.619 109.975L24.005 496H56v-55.636c.4-8.231 10.476-188.35 107.032-256.936l5.66-4.021l.93-6.881C174.437 136.9 191.077 78.058 248 59.971V182.16h75.457a22.12 22.12 0 0 1 21 14.974c12.757 37.656 34.677 84.777 68.839 106.921l-10.274 38.528a62.69 62.69 0 0 1-62.54 46.87c-28.668-.86-58.506 2.88-88.689 11.111L240 403.779V496h32v-67.532a265.4 265.4 0 0 1 67.52-7.03a94.97 94.97 0 0 0 94.418-70.61l17.088-64.081l-12.726-5.454c-23.8-10.2-46.364-43.735-63.538-94.427\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default cat
